import { TTranslator } from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { TLocalesKeys } from 'localization';

export const formatPeople = (
  count: number,
  t: TTranslator<TLocalesKeys>
): string => `${count} ${t('contracted.persons')}`;

export const getFormattedDate =
  (format = 'D MMM') =>
  (date: string): string =>
    date
      .split(' - ')
      .map((item) => dayjs(item, 'YYYY-DD-MM').format(format))
      .join(' - ');
